import { Loader2, ChevronDown, RefreshCw } from "lucide-react";
import { GoldAction } from "@/components/admin/GoldUi";

// Shared "Mehr laden" control for P1-B cursor lists. Only rendered when hasMore.
// Shows a retry affordance on error without discarding already-loaded rows.
export default function LoadMore({ hasMore, loading, error, onLoad, testid = "load-more" }) {
  if (!hasMore) return null;
  return (
    <div className="mt-5 flex flex-col items-center gap-2">
      {error && (
        <p role="alert" className="text-sm" style={{ color: "#903824" }} data-testid={`${testid}-error`}>
          Laden fehlgeschlagen. Bitte erneut versuchen.
        </p>
      )}
      <GoldAction full
        onClick={onLoad}
        disabled={loading}
        data-testid={testid}
      >
        {loading ? <Loader2 size={16} className="animate-spin" /> : error ? <RefreshCw size={16} /> : <ChevronDown size={16} />}
        {loading ? "Wird geladen …" : error ? "Erneut versuchen" : "Mehr laden"}
      </GoldAction>
    </div>
  );
}
